import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { HTRequest, HTRequestStatus, HTRequestType } from "../../api/entities";
import React, { Component, MouseEvent } from "react";
import Context from "../../Context";
import Description from "../components/Description";
import Status from "../components/Status";
import HandoverDocs from "../components/HandoverDocs";
import { JQModal } from "@my-dld/components/Popup/Utils";
import { buildRegDescription, buildRegHandoverDocs, buildRegStatus, extractPropInfo } from "../../Utils";
import PageContent from "@my-dld/components/PageContent";
import PageTitle from "@my-dld/components/PageTitle";
import PersonInfo from "../components/PersonInfo";
import Strings from "@my-dld/assets/strings";
import SuccessPopup from "../components/SuccessPopup";
import { hideLoading, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { submitRequest, validateResponse } from "../../api/api";
import { trackEventWithData } from "@my-dld/utils/Analytics";

export interface HTFormProps extends RoutedViewProps {

}

export interface HTFormState {
	actionId?: HTRequestStatus;
	reqNo?: string;
}

class Handover extends Component<HTFormProps, HTFormState> {
	static contextType = Context;
	context!: React.ContextType<typeof Context>;
	descriptionRef = React.createRef<Description>();
	statusRef = React.createRef<Status>();
	docRef = React.createRef<HandoverDocs>();

	constructor( props: HTFormProps ) {
		super( props );
		this.state = {};
	}

	componentWillUnmount() {
		JQModal( "SuccessPopup" ).hide();
	}

	render() {
		const { request } = this.context;
		const { val, lbl } = extractPropInfo( request );
		const { actionId, reqNo } = this.state;
		return <PageContent
			title={ `${ Strings.ejari_handover_request } - ${ lbl } : ${ val }` }
			hideQLinks={ true }>
			<PageTitle title={ Strings.ejari_handover_request }/>
			<PersonInfo mode={ "edit" }/>
			<Status ref={ this.statusRef } mode={ "edit" }/>
			<Description ref={ this.descriptionRef } mode={ "edit" }/>
			<HandoverDocs ref={ this.docRef } mode={ "edit" }/>
			<div className="row">
				<div className="col-md-12">
					<div className="form-group">
						<a
							href="#" className="btn btn-grey btn_style1 me-2"
							onClick={ this.onCancel }>{ Strings.cancel }</a>
						<button
							className="btn btn_1 btn_style1"
							onClick={ this.onDraft }>{ Strings.save_as_draft }</button>
						<button
							className="btn btn_1 btn_style1 ms-2"
							onClick={ this.onSubmit }>{ Strings.submit }</button>
					</div>
				</div>
			</div>
			{ reqNo && <SuccessPopup
				actionId={ actionId } reqType={ request!.RequestTypeId }
				reqNo={ reqNo } onDismiss={ this.onDismiss }/> }
		</PageContent>;
	}

	private onCancel = ( e: MouseEvent ) => {
		e.preventDefault();
		this.props.history.goBack();
	};

	private onDraft = ( e: MouseEvent ) => {
		e.preventDefault();
		this.onSubmitRequest( HTRequestStatus.DRAFT );
	};

	private onSubmit = ( e: MouseEvent ) => {
		e.preventDefault();
		this.onSubmitRequest( HTRequestStatus.SUBMITTED );
	};

	private onSubmitRequest( status: HTRequestStatus ) {
		const { request } = this.context;
		request!.RequestStatusId = status;
		const promises: Promise<any>[] = [];
		promises.push( this.statusRef.current!.getStatusId() );
		promises.push( this.descriptionRef.current!.getDescription() );
		promises.push( this.docRef.current!.getDocuments() );
		Promise.all( promises ).then( ( promises: any[] ) => {
			showLoading();
			buildRegStatus( request!, promises[ 0 ] );
			buildRegDescription( request!, promises[ 1 ] );
			buildRegHandoverDocs( request!, promises[ 2 ] ).then( submitRequest )
			.then( validateResponse ).then( resp => {
				addHTAnalytics( "Success", request, resp.RequestNumber );
				hideLoading();
				this.setState( {
					actionId: status,
					reqNo: resp.RequestNumber,
				} );
			} ).catch( reason => {
				addHTAnalytics( "Failed", request );
				hideLoading();
				showErrorMessage( reason );
			} );
		} );
	}

	private onDismiss = () => {
		this.setState( {
			reqNo: undefined
		}, () => {
			this.props.history.goBack();
		} );
	};
}

export function addHTAnalytics( actionType: string, request?: HTRequest, reqNo?: string ) {
	const category = ( request?.RequestTypeId === HTRequestType.HANDOVER ) ? "Handover" : "Takeover";
	let action = ( request?.RequestStatusId === HTRequestStatus.DRAFT ) ? "Draft" : "Submit";
	let contractNo = request?.Properties[ 0 ].ContractNumber;
	let data: any = { contractNo: contractNo };
	if ( reqNo ) {
		data = { ...data, reqNo: reqNo };
	}
	if ( action === "Submit" ) {
		trackEventWithData( "AppTransaction", action, data );
	}
	trackEventWithData( category, `${ action }${ actionType }`, data );
}

export default Handover;
